import { api } from "./http-client";
import { PromotionPeriod, CreatePromotionPeriodDto, UpdatePromotionPeriodDto } from "../interfaces/promotion-period.interface";

export const promotionPeriodsService = {
  list: async (page = 1, take = 20): Promise<{ data: PromotionPeriod[]; meta: any }> => {
    const res = await api.request<any>({ url: "/admin/promotion-periods", method: "GET", params: { page, take } });
    return res.data;
  },

  create: async (dto: CreatePromotionPeriodDto): Promise<PromotionPeriod> => {
    const res = await api.request<PromotionPeriod>({ url: "/admin/promotion-periods", method: "POST", data: dto });
    return res.data;
  },

  update: async (id: string, dto: UpdatePromotionPeriodDto): Promise<PromotionPeriod> => {
    const res = await api.request<PromotionPeriod>({ url: `/admin/promotion-periods/${id}`, method: "PUT", data: dto });
    return res.data;
  },

  remove: async (id: string): Promise<void> => {
    await api.request({ url: `/admin/promotion-periods/${id}`, method: "DELETE" });
  },
};
